module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/circle-9815a0c25c1cfc1e70352d97b4223731.svg";